// file path: src\Components\LoaderComponent.tsx

import React from 'react';
import { Typography } from 'antd';
import WorkOwlAnimation from './WorkOwlAnimation/WorkOwlAnimation';

interface LoaderComponentProps {
  msg?: string;
}

const LoaderComponent: React.FC<LoaderComponentProps> = ({ msg = "Loading..." }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100vh',
        width: '100%',
        background: 'rgba(0, 0, 0, 0.1)',
      }}
    >
      <WorkOwlAnimation />
      <Typography.Title level={5} style={{ marginTop: '16px' }}>
        {msg}
      </Typography.Title>
    </div>
  );
};

export default LoaderComponent;
